export { default } from "./CartBody";



// WEBPACK FOOTER //
// ./src/components/sale/posSection/cartTable/cartBody/index.js